import { ReactNode } from "react"

export default function QuestionLabel({ number, children }: { number: number; children: ReactNode }) {
    return (
        <span className="flex items-center gap-2 font-bold text-pale">
            <span
                aria-hidden="true"
                className="flex size-6 shrink-0 items-center justify-center rounded-full bg-rm-blue text-sm text-white"
            >
                {number}
            </span>
            {children}
        </span>
    )
}
